import { IElement } from '../Element';
import { IIdentifier } from '../Identifier';

export interface IReference extends IElement {
  reference?: string;
  identifier?: IIdentifier;
  display?: string;
}

export const getReferenceId = (reference?: IReference) => {
  if (!reference || !reference.reference) return undefined;

  const ref = reference.reference;
  const splits = ref.split('/');
  return splits[splits.length - 1];
};

export const isQuestionnaireReference = (reference: IReference) => {
  if (!reference || !reference.reference) return undefined;

  const ref = reference.reference;
  const splits = ref.split('/');
  return splits[splits.length - 2] === 'QuestionnaireResponse';
};

export const getFirstQuestionnaireReference = (references?: IReference[]) => {
  if (!references) return undefined;
  const filtered = references.filter(
    reference => reference.reference && isQuestionnaireReference(reference),
  );

  return filtered[0];
};

export const createReferrence = (
  reference: string,
  identifier?: IIdentifier,
  display?: string,
): IReference => ({ reference, identifier, display });

export const createOrganizationReference = (resourceId: string) =>
  createReferrence(`Organization/${resourceId}`);

export const createConditionReference = (resourceId: string) =>
  createReferrence(`Condition/${resourceId}`);

export const createQuestionnaireReference = (resourceId: string) =>
  createReferrence(`Questionnaire/${resourceId}`);

export const createQuestionnaireResponseReference = (resourceId: string) =>
  createReferrence(`QuestionnaireResponse/${resourceId}`);

export const createPractitionerReference = (resourceId: string) =>
  createReferrence(`Practitioner/${resourceId}`);

export const createCarePlanReference = (resourceId: string) =>
  createReferrence(`CarePlan/${resourceId}`);

export const createPatientReference = (resourceId: string) =>
  createReferrence(`Patient/${resourceId}`);

export const isQuestionnaireEqualById = (
  reference: IReference | undefined,
  id: string | undefined,
) => {
  if (!reference || (reference && !reference.reference)) return false;
  // TODO: find a better way for equality.
  if (reference.reference === `Questionnaire/${id}`) return true;

  return false;
};
